import React from "react";
import ServicesMenu from "../../components/ServicesMenu/ServicesMenu";

function ServiceConatiner() {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-4">
          <ServicesMenu
            text="Brand Startegy"
            url="https://res.cloudinary.com/emishalabs/image/upload/v1586387628/Famoron%20Assets/development_lmetzi.svg"
          />
        </div>

        <div className="col-lg-4">
          <ServicesMenu
            text="UI / UX"
            url="https://res.cloudinary.com/emishalabs/image/upload/v1586387628/Famoron%20Assets/uiuxdesign_iskm8l.svg"
          />
        </div>

        <div className="col-lg-4">
          <ServicesMenu
            text="Product Design"
            url="https://res.cloudinary.com/emishalabs/image/upload/v1586387628/Famoron%20Assets/productdesign_jmh5ju.svg"
          />
        </div>
        <div className="col-lg-4">
          <ServicesMenu
            text="Web Apps"
            url="https://res.cloudinary.com/emishalabs/image/upload/v1586387628/Famoron%20Assets/webdesign_uqkw6o.svg"
          />
        </div>

        <div className="col-lg-4">
          <ServicesMenu
            text="Mobile Apps"
            url="https://res.cloudinary.com/emishalabs/image/upload/v1586387628/Famoron%20Assets/appdesign_dpdwjz.svg"
          />
        </div>

        <div className="col-lg-4">
          <ServicesMenu
            text="Design Systems"
            url="https://res.cloudinary.com/emishalabs/image/upload/v1586387628/Famoron%20Assets/designsystem_sdjoeu.svg"
          />
        </div>
      </div>
    </div>
  );
}

export default ServiceConatiner;
